/**
 * Created by WebStorm.
 * User: Mehedi Hasan
 * Date: 09 Jan 2025
 * Time: 10:21 AM
 * Email: mdmehedihasanroni28@gmail.com
 */

import React, {createContext, useState} from 'react';
import PMSSubscriptionConfigService from "../services/PMSSubscriptionConfigService";
import {getErrorMessage} from "../helpers/Utils";
import Notification from "../components/common/Notification";

export const PMSSubscriptionConfigContext = createContext("PMSSubscriptionContext");

const PMSSubscriptionContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [pmsSubscriptionConfig, setPMSSubscriptionConfig] = useState(null);

    const [subscriptionReportList, setSubscriptionReportList] = useState(null);

    const [submitLoading, setSubmitLoading] = useState(false);

    async function getPMSSubscriptionConfig() {

        try {

            setLoading(true);

            const res = await PMSSubscriptionConfigService.getPMSSubscriptionConfig();
            setPMSSubscriptionConfig(res.data);

            setLoading(false);

            return res.data;

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }

    async function submitPMSSubscriptionConfig(data) {

        try {

            setSubmitLoading(true);

            await PMSSubscriptionConfigService.submitPMSSubscriptionConfig(data);

            Notification("success", "Config Submit", "Subscription config has been submitted successfully");

            getPMSSubscriptionConfig();

            setSubmitLoading(false);

            return true;

        } catch (error) {

            setSubmitLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }

    async function getSubscriptionReportByPharmacyId(data, id) {

        try {

            setLoading(true);

            const res = await PMSSubscriptionConfigService.getPMSSubscriptionReportByPharmacyId(data, id);
            setSubscriptionReportList(res.data?.content);

            setLoading(false);

            return res.data;

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }

    }


    return (
        <PMSSubscriptionConfigContext.Provider
            value={{
                loading,
                pmsSubscriptionConfig,
                getPMSSubscriptionConfig,
                submitLoading,
                submitPMSSubscriptionConfig,
                getSubscriptionReportByPharmacyId,
                subscriptionReportList

            }}
        >
            {children}
        </PMSSubscriptionConfigContext.Provider>
    );
}

export default PMSSubscriptionContextProvider;

